export default "<input class=\"form-control\" id=\"dummy\" type=\"text\" [(ngModel)]=\"value\" name=\"dummy\">\nin {{value}}\n";